module.exports = __webpack_public_path__ + "static/media/date-icon.b34938c2.svg";